import styled from '@emotion/styled'
import { Container, Grid, useTheme } from '@mui/material'
import React from 'react'
import { Heading, P, SectionHeading, SectionSmallHeading, SectionWrapper } from '../../Styles/style'
import arb from "../../../assets/images/arb.png"
const DIv = styled.div`
  position: relative;
`
const Value = styled.p`
color: #fff;
position: absolute;
    /* top: 29px; */
    left: 70px;
    @media screen and (max-width:1199px){
        bottom: 29px;
        left: 70px;
        font-size: 12px;
    }
`
const Grids = styled(Grid)`
    /* display: flex; */
`

const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 12px 20px;
border-radius: 5px;
margin-right: 15px;
display: flex;
align-items: center;

`
const Bdr = styled.div`
border-left:1px solid #fff;
height: 100px;
text-align: center;
color: #fff;
width: 1px;
@media screen and (max-width:899px){
    border-left:none;
    height: 0px;
    /* display: none; */
    padding: 20px 0;
}
 `
const S6_Tokenomics = () => {
    const theme = useTheme()
    return (
        <div>
            <SectionWrapper p="4rem 0" id="tokenomics">
                <Container maxWidth="xl">
                    <SectionHeading align="left" p="10px 0" m="0" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="500"
                        data-aos-duration="500"
                        data-aos-offset="0">Tokenomics</SectionHeading>
                    <P p="10px 0 40px" m="0" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="500"
                        data-aos-duration="500">A whopping 98% of the tokens are allocated to liquidity, while the remaining 1% are allocated to the team and project marketing.</P>
                    <Grid container>
                        <Grid item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">


                            <Heading>10M</Heading>
                            <SectionSmallHeading align="left" p="0" m="0" color={theme.textTertiary}>Total Supply </SectionSmallHeading>

                        </Grid>
                        <Grid xs={1} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">

                            <Bdr></Bdr>
                        </Grid>
                        <Grid item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">
                            <DIv >
                                <Value>(3% Reflection 2% LP & Marketing)*</Value>
                                <Heading>5%</Heading>
                            </DIv>
                            <SectionSmallHeading p="0" m="0" color={theme.textTertiary}>Buy Tax</SectionSmallHeading>

                        </Grid>
                        <Grid xs={1} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="700"
                            data-aos-duration="500">

                            <Bdr></Bdr>
                        </Grid>
                        <Grid item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="700"
                            data-aos-duration="500">
                            <DIv >
                                <Value>(3% Reflection 2% LP & Marketing)*</Value>
                                <Heading>5%</Heading>
                            </DIv>
                            <SectionSmallHeading p="0" m="0" color={theme.textTertiary}>Sell Tax</SectionSmallHeading>
                            <br />
                            <br />
                        </Grid>

                        <BuyNow data-aos="fade-zoom-in"
                        data-aos-easing="ease-in"
                        data-aos-delay="700"
                        data-aos-duration="500"
                        data-aos-offset="0"><img src={arb} />&nbsp;View Contract On Arbiscan</BuyNow>
                    </Grid>
                </Container>
            </SectionWrapper>
        </div>
    )
}

export default S6_Tokenomics